import { Box, Center, Stack, Text } from '@mantine/core'
import Lottie from 'lottie-react'
import { useState, useEffect } from 'react'
import happyJoyAnimation from '../animations/happy-joy.json'
import chatJoyAnimation from '../animations/chat-joy.json'

interface JoyAIProps {
  variant?: 'happy' | 'chat'
  size?: number
  message?: string
  showMessage?: boolean
}

export function JoyAI({ 
  variant = 'happy', 
  size = 120, 
  message = 'Joy AI is thinking...',
  showMessage = true 
}: JoyAIProps) {
  const [animationData, setAnimationData] = useState<any>(happyJoyAnimation)
  
  useEffect(() => {
    switch (variant) {
      case 'chat':
        setAnimationData(chatJoyAnimation)
        break
      case 'happy':
      default:
        setAnimationData(happyJoyAnimation)
        break
    }
  }, [variant])

  return (
    <Center>
      <Stack gap="md" align="center">
        <Box
          style={{
            width: size,
            height: size,
            background: 'linear-gradient(135deg, #232A5C 0%, #3B82F6 100%)',
            borderRadius: '50%',
            padding: '12px',
            boxShadow: '0 4px 20px rgba(35, 42, 92, 0.3)',
          }}
        >
          <Lottie
            animationData={animationData}
            loop
            style={{
              width: '100%',
              height: '100%',
            }}
          />
        </Box>
        
        {showMessage && (
          <Text
            size="sm"
            fw={500}
            c="dimmed"
            ta="center"
            style={{
              fontFamily: "'proxima-nova', 'Proxima Nova', sans-serif",
            }}
          >
            {message}
          </Text>
        )}
      </Stack>
    </Center>
  )
}